import { render } from "./ButtonComponent.vue?vue&type=template&id=747047ee&scoped=true"
import script from "./ButtonComponent.vue?vue&type=script&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&lang=js"

import "./ButtonComponent.vue?vue&type=style&index=0&id=747047ee&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747047ee"]])

export default __exports__